// ============================================================
// Datei: src/pages/ressorts/parkplatz/ParkplatzMobile.jsx
//
// ÄNDERUNGEN:
// - ShiftTable jetzt mit departmentName
// - automatische Aktualisierung bleibt erhalten
// - bei nur einem Block ist kein filterFn nötig
// ============================================================

import React, { useState } from "react";

import VolunteerList from "../../../components/VolunteerList";
import VolunteerPool from "../../../components/VolunteerPool";
import ShiftTable from "../../../components/shiftTable/ShiftTable";

import GuestRegistration from "../../../components/GuestRegistration";
import GuestList from "../../../components/guestList/GuestList";
import EditGuestModal from "../../../components/guestList/EditGuestModal";
import DeleteGuestModal from "../../../components/guestList/DeleteGuestModal";

import "./parkplatzMobile.css";

const ParkplatzMobile = ({
	volunteers,
	setVolunteers,
	shifts,
	guests,
	activeTab,
	setActiveTab,
	reloadGuests,
	reloadVolunteers,
	setSelectedVolunteer,
	downloadCcEmails
}) => {
	const [guestToEdit, setGuestToEdit] = useState(null);
	const [guestToDelete, setGuestToDelete] = useState(null);
	const [helpersSubTab, setHelpersSubTab] = useState("ressort");

	const parkplatz = shifts.filter(
		(s) => s.shiftId >= 801 && s.shiftId <= 810
	);

	const tabs = [
		{ id: "overview", label: "Übersicht" },
		{ id: "helpers", label: "Libellen" },
		{ id: "shifts", label: "Schichtplan" },
		{ id: "guests", label: "Gästeliste" },
		{ id: "extras", label: "Extrawürscht" }
	];

	return (
		<>
			<div className="tabs-container">
				<div className="tab-bar">
					{tabs.map((t) => (
						<button
							key={t.id}
							type="button"
							className={
								"tab-button" +
								(activeTab === t.id ? " tab-button-active" : "")
							}
							onClick={() => setActiveTab(t.id)}
						>
							{t.label}
						</button>
					))}
				</div>

				<div className="tab-panels">
					{activeTab === "helpers" && (
						<div className="parkplatz-mobile-helpers-panel">
							<div className="helpers-subtab-bar">
								<button
									type="button"
									className={
										"helpers-subtab-button" +
										(helpersSubTab === "ressort"
											? " helpers-subtab-button-active"
											: "")
									}
									onClick={() => setHelpersSubTab("ressort")}
								>
									Ressort
								</button>

								<button
									type="button"
									className={
										"helpers-subtab-button" +
										(helpersSubTab === "pool"
											? " helpers-subtab-button-active"
											: "")
									}
									onClick={() => setHelpersSubTab("pool")}
								>
									Helferpool
								</button>
							</div>

							{helpersSubTab === "ressort" && (
								<VolunteerList
									volunteers={volunteers}
									setVolunteers={setVolunteers}
									onEdit={setSelectedVolunteer}
									reloadVolunteers={reloadVolunteers}
								/>
							)}

							{helpersSubTab === "pool" && (
								<VolunteerPool
									departmentName="Parkplatz"
									onAssigned={() => {
										if (reloadVolunteers) {
											reloadVolunteers();
										}
									}}
								/>
							)}
						</div>
					)}

					{activeTab === "shifts" && (
						<>
							<h3 className="parkplatz-subheading">Parkplatz</h3>
							<ShiftTable
								shifts={parkplatz}
								departmentName="Parkplatz"
								autoRefresh={true}
							/>
						</>
					)}

					{activeTab === "guests" && (
						<>
							<GuestRegistration refreshGuestList={reloadGuests} />

							<GuestList
								guests={guests}
								refreshGuestList={reloadGuests}
								onEdit={(g) => setGuestToEdit(g)}
								onDelete={(g) => setGuestToDelete(g)}
							/>
						</>
					)}

					{activeTab === "extras" && <div></div>}
				</div>
			</div>

			{guestToEdit && (
				<EditGuestModal
					guest={guestToEdit}
					onClose={() => setGuestToEdit(null)}
					onSaved={() => {
						setGuestToEdit(null);
						reloadGuests();
					}}
				/>
			)}

			{guestToDelete && (
				<DeleteGuestModal
					guest={guestToDelete}
					onClose={() => setGuestToDelete(null)}
					onDeleted={() => {
						setGuestToDelete(null);
						reloadGuests();
					}}
				/>
			)}
		</>
	);
};

export default ParkplatzMobile;